import history from './history';
import createStore from './redux/create-store';

const store = createStore(history);
export default store;
